var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":'https://fhh-map.q12301.com?scenic_id=' + _vm.scenic_id + '&points=' + _vm.points}})])
}
var staticRenderFns = []

export { render, staticRenderFns }